import React from "react";
import { Grid, TextField, IconButton } from "@mui/material";
import { Delete } from "@mui/icons-material";

interface InvoiceRowInputProps {
  row: {
    description: string;
    quantity: string;
    unitPrice: string;
  };
  rowTotal: number;
  onChange: (field: string, value: string) => void;
  onRemove: () => void;
  canRemove: boolean;
}

export const InvoiceRowInput: React.FC<InvoiceRowInputProps> = ({
  row,
  rowTotal,
  onChange,
  onRemove,
  canRemove,
}) => {
  return (
    <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
      <Grid item xs={12} md={5}>
        <TextField
          label="Kuvaus"
          value={row.description}
          onChange={(e) => onChange("description", e.target.value)}
          fullWidth
          variant="outlined"
          size="small"
          placeholder="esim. Tiehoitomaksu 2024"
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <TextField
          label="Määrä"
          value={row.quantity}
          onChange={(e) => onChange("quantity", e.target.value)}
          fullWidth
          variant="outlined"
          size="small"
          type="number"
          inputProps={{ step: "0.001", min: "0.001" }}
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <TextField
          label="Yksikköhinta (€)"
          value={row.unitPrice}
          onChange={(e) => onChange("unitPrice", e.target.value)}
          fullWidth
          variant="outlined"
          size="small"
          type="number"
          inputProps={{ step: "0.01", min: "0.01" }}
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <TextField
          label="Yhteensä (€)"
          value={rowTotal.toFixed(2)}
          fullWidth
          variant="outlined"
          size="small"
          disabled
          InputProps={{
            readOnly: true,
          }}
        />
      </Grid>
      <Grid item xs={12} md={1}>
        <IconButton
          color="error"
          onClick={onRemove}
          disabled={!canRemove}
          size="small"
        >
          <Delete />
        </IconButton>
      </Grid>
    </Grid>
  );
};
